import { useQuery } from '@tanstack/react-query';
import { getSupportTicketOpenCount } from '../api/supportTickets.api';
import { queryKeys } from '../api/queryKeys';

/**
 * How many support tickets nobody has picked up - the sidebar badge.
 *
 * Fetched once and then left alone, like `useChatUnreadCount` and unlike the
 * verifications badge beside it: every `support_ticket_updated` carries the new
 * count and writes it straight into this cache, and so does every page of the
 * list. Polling on top of that would be asking a question already answered.
 *
 * The long staleTime is the safety net for the case the socket cannot cover:
 * a tab that was asleep while tickets moved refetches when it is looked at
 * again.
 */
export function useSupportTicketOpenCount({ enabled = true } = {}) {
  const query = useQuery({
    queryKey: queryKeys.supportTickets.openCount,
    queryFn: async () => {
      const { data } = await getSupportTicketOpenCount();
      return data.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return { open: query.data?.open ?? 0, isLoading: query.isLoading };
}
